//@flow
import {Typography} from '@material-ui/core';
import {Publish} from '@material-ui/icons';
import {makeStyles} from '@material-ui/styles';
import React from 'react';
import {useState} from 'react';

import defaultImage from '../../../../assets/img/image-default.jpg';
import {colors} from '../../../../assets/styles/colors';

type Props = {
  onUpload?: (file: File) => void,
};

const useStyles = makeStyles(theme => ({
  root: {
    display: 'flex',
    border: `2px dashed ${colors.grey500}`,
    borderRadius: 12,
    height: 96,
    padding: 8,
    alignItems: 'center',
    gap: theme.spacing(2),
    width: '100%',
    cursor: 'pointer',
  },
  preview: {
    height: '100%',
    aspectRatio: '1/1',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',

    '& img': {
      height: '100%',
      width: '100%',
      objectFit: 'contain',
    },
  },
  input: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: theme.spacing(1),
    color: colors.purple,
    width: '100%',
  },
  purpleText: {
    fontSize: '12px',
  },
  grayText: {
    fontSize: '12px',
    color: colors.grey500,
  },
}));

export default function UploadImage({onUpload}: Props) {
  const classes = useStyles();

  const [file, setFile] = useState();

  const handleChange = (event: SyntheticInputEvent<HTMLInputElement>) => {
    const file = event.target.files[0];
    if (!file) return;
    setFile(file);
    onUpload && onUpload(file);
  };

  return (
    <label className={classes.root}>
      <picture className={classes.preview}>
        {file ? (
          <img src={URL.createObjectURL(file)} alt="preview" />
        ) : (
          <img src={defaultImage} alt="default" />
        )}
      </picture>
      <div className={classes.input}>
        <Publish />
        <Typography className={classes.purpleText}>
          Sube imagen de logo
        </Typography>
        <Typography className={classes.grayText}>(Opcional)</Typography>
        <input type="file" name="file" hidden onChange={handleChange} />
      </div>
    </label>
  );
}
